import {domain} from './APIConstant';

export const routeCategoryAPI={
    main: domain+'/api/category',
    disable: domain+'/api/category/status/disable',  
    enable: domain+'/api/category/status/enable',  
}